import { CdkDragDrop, moveItemInArray, CdkDragStart, CdkDragEnd } from '@angular/cdk/drag-drop';
import {
	AfterViewInit,
	Component,
	ContentChildren,
	Directive,
	Input,
	OnDestroy,
	QueryList,
	ViewChild,
	ViewChildren,
	ViewEncapsulation
} from '@angular/core';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { NavigationEnd, Router, RouterLink, UrlTree } from '@angular/router';
import { Subscription } from 'rxjs';
import { IRouterState } from '../../router-state';
import { TabsService, Tab } from '../tabs.service';

// Directive to retrieve mat-tab options from router-tab.component.html
@Directive({
	// tslint:disable-next-line:directive-selector
	selector: 'mat-tab[routerLink]'
})
// tslint:disable-next-line:directive-class-suffix
export class RouterTab {
	@Input()
	public routerLinkActiveOptions: {
		exact: boolean;
	};

	constructor(public tab: MatTab, public routerLink: RouterLink) {}
}

// Directive to set tabs within app-router-tab

// tslint:disable-next-line:directive-selector
@Directive({ selector: 'app-router-tab-item' })
// tslint:disable-next-line:directive-class-suffix
export class RouterTabItem {
	@Input()
	public routerLink: RouterLink;
	@Input()
	public routerLinkActiveOptions: {
		exact: boolean;
	};
	@Input() actives: IRouterState;

	// tslint:disable-next-line:no-input-rename
	@Input('disabled')
	public disabled: boolean;

	@Input()
	public label: string;
}

// RouterTab component with the same behavior than mat-tab-nav-bar
@Component({
	// tslint:disable-next-line:component-selector
	selector: 'app-router-tab',
	templateUrl: './router-tab.component.html',
	styleUrls: ['./router-tab.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class RouterTabComponent implements AfterViewInit, OnDestroy {
	@ViewChild('matTabGroup', { static: true })
	public matTabGroup: MatTabGroup;
	@ContentChildren(RouterTabItem)
	public routerTabItems!: QueryList<RouterTabItem>;

	@ViewChildren(RouterTab)
	public routerTabs: QueryList<RouterTab>;

	tabpaixu: Number;
	tabBool: number;
	oldTab: Tab;
	@Input() active: IRouterState;
	private subscription = new Subscription();
	dragStart(event: CdkDragStart, index: number) {
		this.tabBool = index;
		this.oldTab = this.tabs.active;
	}
	dragEnded(event: CdkDragEnd) {
		this.tabBool = null;
	}
	drop(event: CdkDragDrop<string[]>) {
		// tslint:disable-next-line:radix
		const previousIndex = parseInt(event.previousContainer.id.replace('list-', ''));
		// tslint:disable-next-line:radix
		const currentIndex = parseInt(event.container.id.replace('list-', ''));
		if (
			previousIndex !== NaN &&
			currentIndex !== NaN &&
			previousIndex !== undefined &&
			currentIndex !== undefined &&
			previousIndex !== currentIndex
		) {
			// Do stuff
			// this.tabBool = null;
			// END Stuff
			moveItemInArray(this.tabs.tabs, previousIndex, currentIndex);
		}
		this.tabs.activeIndex = this.tabs.tabs.findIndex(v => v === this.oldTab);
	}
	getAllListConnections(index: Number) {
		const connections = [];
		for (let i = 0; i < this.tabs.tabs.length; i++) {
			if (i !== index) {
				connections.push('list-' + i);
			}
		}
		return connections;
	}
	constructor(private router: Router, public tabs: TabsService) {}

	ngAfterViewInit() {
		// Remove tab click event
		this.matTabGroup._handleClick = () => {};
		// Select current tab depending on url
		this.setIndex();
		// Subscription to navigation change
		// this.subscription.add(
		// 	this.router.events.subscribe(e => {
		// 		if (e instanceof NavigationEnd) {
		// 			setTimeout(() => this.setIndex(), 0);
		// 		}
		// 	})
		// );
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
	getURLPath(u: UrlTree) {
		return ['/', ...u.root.children['primary'].segments.map(v => v.path)];
	}
	onTabsClick(event: MouseEvent, index: number) {
		if (this.tabs.activeIndex !== index) {
			this.router.navigateByUrl(this.tabs.tabs[index].url, {
				state: this.tabs.tabs[index].data()
			});
		}
	}
	removeClick(e: MouseEvent, index: number) {
		if (this.tabs.removeTab(index)) {
			this.router.navigateByUrl(this.tabs.active.url, {
				state: this.tabs.active.data()
			});
		}
		if (e && e.stopPropagation) {
			// å æ­¤å®æ¯æW3CçstopPropagation()æ¹æ³
			e.stopPropagation();
		} else {
			// å¦åï¼æä»¬éè¦ä½¿ç¨IEçæ¹å¼æ¥åæ¶äºä»¶åæ³¡
			window.event.cancelBubble = true;
		}
		return false;
	}
	// Set current selected tab depending on navigation
	private setIndex() {
		this.routerTabs.find((tab, i) => {
			if (
				!this.router.isActive(
					tab.routerLink.urlTree,
					tab.routerLinkActiveOptions ? tab.routerLinkActiveOptions.exact : false
				)
			) {
				return false;
			}
			// tab.tab.isActive = true;
			this.tabs.activeIndex = i;
			// this.matTabGroup.selectedIndex = i;
			return true;
		});
	}
}
